import t from"./isObject.js";var r=Object.create,e=function(){function e(){}return function(n){if(!t(n))return{};if(r)return r(n);e.prototype=n;var o=new e;return e.prototype=void 0,o}}();export{e as default};
//# sourceMappingURL=_baseCreate.js.map
